import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-left-arrow",
  "use": "icon-left-arrow-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-left-arrow\"><defs><style type=\"text/css\"></style></defs><path d=\"M1024 438.857143H270.628571l321.828572-336.457143L490.057143 0 0 512l490.057143 512 102.4-102.4L270.628571 585.142857H1024V438.857143z\" p-id=\"1041\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol